import React, { forwardRef } from "react"
import "./styles.scss"

const Textarea = forwardRef(({ invalid, className = "", inputClassName = "", ...props }, ref) => {
  return <div className={`input-text-area-container row ${className} ${invalid ? 'invalid' : ''}`}>
    <textarea ref={ref} className={`input-text-area ${inputClassName}`} {...props} />
  </div>
})

export default Textarea